'use client';

import { useEffect } from 'react';
import { track } from '@/lib/analytics/events';

export default function ScrollDepth() {
  useEffect(() => {
    const W = window as any;
    if (W.__bs_scrollInstalled) return; // install once (survive Strict Mode)
    W.__bs_scrollInstalled = true;
    W.__bs_scrollDepthFired = W.__bs_scrollDepthFired || new Set<number>();
    const fired: Set<number> = W.__bs_scrollDepthFired;
    const breaks = [25, 50, 75]; // keep EM's 90% separate

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        try {
          const el = document.documentElement;
          const max = el.scrollHeight - el.clientHeight;
          if (max > 0) {
            const pct = Math.round((el.scrollTop / max) * 100);
            for (const b of breaks)
              if (pct >= b && !fired.has(b)) {
                fired.add(b);
                track.scrollDepth({ depth_percent: b });
              }
          }
        } finally {
          ticking = false;
        }
      });
    };

    onScroll();
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll);
    // Note: no removal; Strict Mode remount-safe via guard
  }, []);

  return null;
}
